import React from 'react';

export const OutgoingCallIcon = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7559 5.24115C15.0814 5.56658 15.0814 6.09422 14.7559 6.41966L6.42259 14.753C6.09715 15.0784 5.56951 15.0784 5.24408 14.753C4.91864 14.4276 4.91864 13.8999 5.24408 13.5745L13.5774 5.24115C13.9028 4.91571 14.4305 4.91571 14.7559 5.24115Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83333 5.8304C5.83333 5.37017 6.20643 4.99707 6.66667 4.99707H14.1667C14.6269 4.99707 15 5.37017 15 5.8304V13.3304C15 13.7906 14.6269 14.1637 14.1667 14.1637C13.7064 14.1637 13.3333 13.7906 13.3333 13.3304V6.66374H6.66667C6.20643 6.66374 5.83333 6.29064 5.83333 5.8304Z"
      fill="#6B7280"
    />
  </svg>
);
